import React from 'react'
import {
  Datagrid,
  TextField,
  BooleanField,
  Filter,
  TextInput,
  BulkDeleteWithConfirmButton,
} from 'react-admin'
import KPagination from 'ui-shared/KPagination'
import { BaseListProps } from 'ui-shared/WrappedInputs/CatalogItemBaseList'
import SectionWrapper from 'ui-shared/LayoutComponents/SectionWrapper'
import { FILTER_SOURCES } from 'services/cfg/filter'
import KList from 'ui-shared/KWrappers/KList'

const CouponFilter: React.FC = (props) => (
  <Filter {...props}>
    <TextInput label="Name" source={FILTER_SOURCES.name} alwaysOn />
  </Filter>
)

const CouponList: React.FC<BaseListProps> = (props) => {
  return (
    <SectionWrapper>
      <KList
        pagination={<KPagination />}
        perPage={40}
        {...props}
        exporter={false}
        sort={{ field: 'code', order: 'ASC' }}
        filters={<CouponFilter />}
      >
        <Datagrid
          rowClick="edit"
          bulkActionButtons={
            <BulkDeleteWithConfirmButton mutationMode="optimistic" />
          }
        >
          <TextField source="name" />
          <TextField source="code" />
          <BooleanField source="enabled" sortable={false} />
        </Datagrid>
      </KList>
    </SectionWrapper>
  )
}

export default CouponList
